import ResponsiveNavbar from "../main/ResponsiveNavbar";
import Footer from "../main/Footer";
import FoodItems from "./FoodItems";
function Menu() {
  return (
    <>
      <ResponsiveNavbar />
      <FoodItems />
      <Footer />
    </>
  );
}

export default Menu;
